module.exports = __webpack_public_path__ + "img/shield.040cf71d.svg";